import api from "../api";
import { 
  login_endpoint, 
  auth_endpoint,
  dashboard_endpoint, 
  users_endpoint, 
  busOwners_endpoint, 
  drivers_endpoint, 
  conductors_endpoint,
  bookings_endpoint,
  customer_endpoints,
  coupons_endpoint,
  payment_endpoint,
    admin_profile_endpoint,
    commission_endpoint,
    influencers_endpoint,
route_endpoint,
admin_term_endpoint,
admin_layout_endpoint,
employee_endpoint,bus_endpoint,
freelancer_endpoint,profit_endpoint,customerCare_endpoint, admin_expense_endpoint,master_route_endpoint,gst_endpoint,bookingPolicy_endpoint,booking_endpoint} from "../api_endpoints";

const { login_API } = login_endpoint;
const { getAllTerm } = admin_term_endpoint;
const { getAllLayout, getAllCategories } = admin_layout_endpoint;
const { dashboard_API } = dashboard_endpoint;
const { route_API } = route_endpoint;
const { users_API } = users_endpoint;
const { bookingFilter_API } = booking_endpoint;
const { 
  busOwners_API, 
  getBusOwnerById: getBusOwnerByIdEndpoint, 
  updateBusOwner: updateBusOwnerEndpoint,
  deleteBusOwner: deleteBusOwnerEndpoint ,
  approvedBusOwnerById : approvedBusOwnerById
} = busOwners_endpoint;
const { 
  addBusToOwnerApi 
} = busOwners_endpoint;
const { drivers_API } = drivers_endpoint;
const { conductors_API } = conductors_endpoint;

const { 
  getCustomers: customersEndpoint, 
  getCustomerById: getCustomerByIdEndpoint, 
  updateCustomer: updateCustomerEndpoint 
} = customer_endpoints;

const { 
  bookings_API,
  getBookingById: getBookingByIdEndpoint,
  updateBooking: updateBookingEndpoint,
  updateBookingStatus: updateBookingStatusEndpoint
} = bookings_endpoint;

const { 
  coupons_API,
  getCouponById: getCouponByIdEndpoint,
  updateCoupon: updateCouponEndpoint,
  deleteCoupon: deleteCouponEndpoint
} = coupons_endpoint;

const { 
  payments_API,
  getPaymentById: getPaymentByIdEndpoint,
  processPayment: processPaymentEndpoint,
  refundPayment: refundPaymentEndpoint
} = payment_endpoint;

const {
  getAdminProfile: getAdminProfileEndpoint,
  updateAdminProfile: updateAdminProfileEndpoint,
  changeAdminPassword: changeAdminPasswordEndpoint,
  updateAdminSettings: updateAdminSettingsEndpoint
} = admin_profile_endpoint;

const { 
  getCommissionReports: getCommissionReportsEndpoint,
  getBusOwnerCommission: getBusOwnerCommissionEndpoint,
  updateBusOwnerCommission: updateBusOwnerCommissionEndpoint,
  processCommissionPayout: processCommissionPayoutEndpoint,

  getInfluencerCommissionses: getInfluencerCommissionsEndpoint,
  getCommissionStats: getCommissionStatsEndpoint,
  getCommissionById: getCommissionByIdEndpoint,
  processBulkPayout: processBulkPayoutEndpoint,

  processCommissionPayment: processCommissionPaymentEndpoint,
  getCommissionStats: getCommissionPaymentHistoryEndpoint,
  getCommissionById: getAllCommissionPaymentsEndpoint,
  processBulkPayout: updatePaymentStatusEndpoint,  
} = commission_endpoint;

const { 
 influencers_API: influencers_API
} = influencers_endpoint;


const { 
  getBusIncome: getBusIncomeEndpoint, 
  getAllBusesIncome: getAllBusesIncomeEndpoint, 
  getBusIncomeSummary: getBusIncomeSummaryEndpoint
} = profit_endpoint;

const {
  employees_API,
  getEmployeeById: getEmployeeByIdEndpoint,
  updateEmployee: updateEmployeeEndpoint,
  deleteEmployee: deleteEmployeeEndpoint,
  permanentDeleteEmployee: permanentDeleteEmployeeEndpoint,
  bulkCreateEmployees: bulkCreateEmployeesEndpoint,
  updatePassword: updatePasswordEndpoint
} = employee_endpoint;

const {
  freelancers_API,
  getFreelancerById: getFreelancerByIdEndpoint,
  updateFreelancer: updateFreelancerEndpoint,
  deleteFreelancer: deleteFreelancerEndpoint,
  permanentDeleteFreelancer: permanentDeleteFreelancerEndpoint,
  bulkCreateFreelancers: bulkCreateFreelancersEndpoint,
  updatePassword: updateFreelancerPasswordEndpoint,
  approveFreelancer: approveFreelancerEndpoint,
  rejectFreelancer: rejectFreelancerEndpoint,
  toggleFreelancerStatus: toggleFreelancerStatusEndpoint,
  updatePermissions: updatePermissionsEndpoint,
  getFreelancerStats: getFreelancerStatsEndpoint
} = freelancer_endpoint;

const { 
  forgotPassword_API, 
  verifyOtp_API, 
  resetPassword_API, 
  resendOtp_API 
} = auth_endpoint;


const {
  bookingPolicies_API,
  getBookingPolicyById: getBookingPolicyByIdEndpoint,
  createBookingPolicy: createBookingPolicyEndpoint,
  updateBookingPolicy: updateBookingPolicyEndpoint,
  deleteBookingPolicy: deleteBookingPolicyEndpoint,
  permanentDeleteBookingPolicy: permanentDeleteBookingPolicyEndpoint,
  toggleBookingPolicyStatus: toggleBookingPolicyStatusEndpoint,
  getActiveBookingPolicy: getActiveBookingPolicyEndpoint,
  getFormattedPolicyText: getFormattedPolicyTextEndpoint,
  validateCancellation: validateCancellationEndpoint
} = bookingPolicy_endpoint;

export const getCustomerCare = async (token) => {
  try {
    console.log("Fetching customer care details...");
    const response = await api.get(customerCare_endpoint.getCustomerCare, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const createCustomerCare = async (data, token) => {
  try {
    console.log("Creating customer care details...", data);
    const response = await api.post(customerCare_endpoint.createCustomerCare, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const updateCustomerCare = async (id, data, token) => {
  try {
    console.log(`Updating customer care with ID: ${id}`, data);
    const response = await api.put(customerCare_endpoint.updateCustomerCare(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const deleteCustomerCare = async (id, token) => {
  try {
    console.log(`Deleting customer care with ID: ${id}`);
    const response = await api.delete(customerCare_endpoint.deleteCustomerCare(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Customer Care Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_CUSTOMER_CARE_API_ERROR..........", error);
    throw error;
  }
};

export const toggleCustomerCareStatus = async (id, token) => {
  try {
    console.log(`Toggling customer care status for ID: ${id}`);
    const response = await api.patch(customerCare_endpoint.toggleCustomerCareStatus(id), {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Toggle Status Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("TOGGLE_CUSTOMER_CARE_STATUS_API_ERROR..........", error);
    throw error;
  }
};

export const getAllBusRouteSchedules = async (token, page = 1, limit = 10, search = '', filters = {}) => {
    try {
        const response = await api.get('/bus-route-schedules', {
            params: {
                page,
                limit,
                search,
                status: filters.status,
                busType: filters.busType,
                routeType: filters.routeType
            },
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching bus route schedules:', error);
        throw error.response?.data || error;
    }
};

export const getBusRouteSchedule = async (busId, token) => {
    try {
        const response = await api.get(`/bus-route-schedule/${busId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching bus route schedule:', error);
        throw error.response?.data || error;
    }
};

// Update Bus Route Schedule
export const updateBusRouteSchedule = async (busId, updateData, token) => {
    try {
        const response = await api.put(`/bus-route-schedule/${busId}`, updateData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating bus route schedule:', error);
        throw error.response?.data || error;
    }
};

// Update Specific Route Schedule within a Bus
export const updateSpecificRouteSchedule = async (busId, routeId, updateData, token) => {
    try {
        const response = await api.put(`/bus-route-schedule/${busId}/route/${routeId}`, updateData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating specific route schedule:', error);
        throw error.response?.data || error;
    }
};

// Get Disabled Dates for a Specific Point
export const getPointDisabledDates = async (busId, pointId, token) => {
    try {
        const response = await api.get(`/bus-route-schedule/${busId}/point/${pointId}/disabled-dates`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching disabled dates:', error);
        throw error.response?.data || error;
    }
};


export const getBusById = async (busId, token) => {
  try {
    const response = await api.get(bus_endpoint.getBusById(busId), {
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log('getBusById response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching bus by ID:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    throw error;
  }
};

export const activateBusWithPlatformFee = async (busId, platformFeeData, token) => {
  try {
    const response = await api.put(
      `/bus/activate/${busId}`,
      platformFeeData,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    console.log('activateBusWithPlatformFee response:', response.data);
    return response.data;
  } catch (error) {
    console.error('ACTIVATE_BUS_WITH_PLATFORM_FEE_ERROR:', error);
    console.error('Error config:', error.config);
    console.error('Error response:', error.response);
    throw error;
  }
};

export const searchMasterRouteIntermediateStops = async (token, searchQuery) => {
  try {
    // Correct the endpoint path - remove the extra '/search'
    const response = await api.get(
      `/cities/route/search?q=${encodeURIComponent(searchQuery)}`,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    console.log('searchMasterRouteIntermediateStops response:', response.data);
    return response.data;
  } catch (error) {
    console.error('SEARCH_MASTER_ROUTE_INTERMEDIATE_STOPS_ERROR:', error);
    console.error('Error config:', error.config);
    console.error('Error response:', error.response);
    throw error;
  }
};

export const searchRouteIntermediateStops = async (token, searchQuery) => {
  try {
    // Correct the endpoint path - use routes instead of master-routes
    const response = await api.get(
      `/cities/masterroute/search?q=${encodeURIComponent(searchQuery)}`,
      {
        headers: { 'Authorization': `Bearer ${token}` }
      }
    );
    console.log('searchRouteIntermediateStops response:', response.data);
    return response.data;
  } catch (error) {
    console.error('SEARCH_ROUTE_INTERMEDIATE_STOPS_ERROR:', error);
    console.error('Error config:', error.config);
    console.error('Error response:', error.response);
    throw error;
  }
};

// Get all booking policies
export const getBookingPolicies = async (token, page = 1, limit = 10, searchTerm = '', isActive = null) => {
  try {
    let url = `${bookingPolicies_API}?page=${page}&limit=${limit}`;
    if (searchTerm) url += `&search=${searchTerm}`;
    if (isActive !== null) url += `&isActive=${isActive}`;
    
    const response = await api.get(url, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_BOOKING_POLICIES_ERROR:', error);
    throw error;
  }
};

// Get booking policy by ID
export const getBookingPolicyById = async (id, token) => {
  try {
    const response = await api.get(getBookingPolicyByIdEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_BOOKING_POLICY_BY_ID_ERROR:', error);
    throw error;
  }
};

// Create new booking policy
export const createBookingPolicy = async (policyData, token) => {
  try {
    const response = await api.post(createBookingPolicyEndpoint, policyData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('CREATE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

// Update booking policy
export const updateBookingPolicy = async (id, policyData, token) => {
  try {
    const response = await api.put(updateBookingPolicyEndpoint(id), policyData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('UPDATE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

// Delete booking policy (soft delete)
export const deleteBookingPolicy = async (id, token) => {
  try {
    const response = await api.delete(deleteBookingPolicyEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('DELETE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

// Permanent delete booking policy
export const permanentDeleteBookingPolicy = async (id, token) => {
  try {
    const response = await api.delete(permanentDeleteBookingPolicyEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('PERMANENT_DELETE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

// Toggle policy status
export const toggleBookingPolicyStatus = async (id, token) => {
  try {
    const response = await api.patch(toggleBookingPolicyStatusEndpoint(id), {}, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('TOGGLE_BOOKING_POLICY_STATUS_ERROR:', error);
    throw error;
  }
};

// Get active booking policy
export const getActiveBookingPolicy = async () => {
  try {
    const response = await api.get(getActiveBookingPolicyEndpoint);
    return response.data;
  } catch (error) {
    console.error('GET_ACTIVE_BOOKING_POLICY_ERROR:', error);
    throw error;
  }
};

// Get formatted policy text
export const getFormattedPolicyText = async (id, token) => {
  try {
    const response = await api.get(getFormattedPolicyTextEndpoint(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_FORMATTED_POLICY_TEXT_ERROR:', error);
    throw error;
  }
};

// Validate cancellation
export const validateCancellation = async (departureDateTime, policyId = null) => {
  try {
    const response = await api.post(validateCancellationEndpoint, {
      departureDateTime,
      policyId
    });
    return response.data;
  } catch (error) {
    console.error('VALIDATE_CANCELLATION_ERROR:', error);
    throw error;
  }
};

// Platform Fees APIs - Add /admin prefix to all URLs
export const getCurrentPlatformFee = async (token) => {
  try {
    const response = await api.get('/platform-fees/current', {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_CURRENT_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const getPlatformFees = async (token, page = 1, limit = 10, filters = {}) => {
  try {
    const params = { page, limit, ...filters };
    const response = await api.get('/platform-fees', {
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_PLATFORM_FEES_ERROR:', error);
    throw error;
  }
};

export const getPlatformFeeById = async (id, token) => {
  try {
    const response = await api.get(`/platform-fees/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_PLATFORM_FEE_BY_ID_ERROR:', error);
    throw error;
  }
};

export const createPlatformFee = async (data, token) => {
  try {
    const response = await api.post('/platform-fees', data, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('CREATE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const updatePlatformFee = async (id, data, token) => {
  try {
    const response = await api.put(`/platform-fees/${id}`, data, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('UPDATE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const deletePlatformFee = async (id, token) => {
  try {
    const response = await api.delete(`/platform-fees/${id}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('DELETE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const calculatePlatformFee = async (amount, bookingType, token) => {
  try {
    const response = await api.post('/platform-fees/calculate', 
      { amount, bookingType },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('CALCULATE_PLATFORM_FEE_ERROR:', error);
    throw error;
  }
};

export const getPlatformFeeStats = async (token) => {
  try {
    const response = await api.get('/platform-fees/stats', {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('GET_PLATFORM_FEE_STATS_ERROR:', error);
    throw error;
  }
};


// GSTR-1 APIs
export const getGSTR1 = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr1, { 
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GSTR-1 error:', error);
    throw error;
  }
};

export const downloadGSTR1CSV = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr1CSV, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-1 CSV error:', error);
    throw error;
  }
};

export const downloadGSTR1PDF = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr1PDF, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-1 PDF error:', error);
    throw error;
  }
};

// GSTR-3B APIs
export const getGSTR3B = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr3b, { 
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GSTR-3B error:', error);
    throw error;
  }
};

export const downloadGSTR3BCSV = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr3bCSV, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-3B CSV error:', error);
    throw error;
  }
};

export const downloadGSTR3BPDF = async (month, year, quarter = null, token) => {
  try {
    const params = { year };
    if (month) params.month = month;
    if (quarter) params.quarter = quarter;
    
    const response = await api.get(gst_endpoint.gstr3bPDF, { 
      params,
      responseType: 'blob',
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Download GSTR-3B PDF error:', error);
    throw error;
  }
};

// Dashboard API
export const getGSTDashboard = async (year, token) => {
  try {
    const response = await api.get(gst_endpoint.dashboard, { 
      params: { year },
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GST Dashboard error:', error);
    throw error;
  }
};

// Invoice APIs
export const getGSTInvoices = async (page = 1, limit = 20, filters = {}, token) => {
  try {
    const params = { page, limit, ...filters };
    const response = await api.get(gst_endpoint.invoices, { 
      params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GST Invoices error:', error);
    throw error;
  }
};

export const getGSTInvoiceById = async (id, token) => {
  try {
    const response = await api.get(gst_endpoint.invoiceById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Get GST Invoice by ID error:', error);
    throw error;
  }
};

export const generateGSTInvoices = async (month, year, token) => {
  try {
    const response = await api.post(gst_endpoint.generateInvoices, 
      { month, year },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Generate GST Invoices error:', error);
    throw error;
  }
};

export const cancelGSTInvoice = async (id, reason, token) => {
  try {
    const response = await api.post(gst_endpoint.cancelInvoice(id), 
      { reason },
      { headers: { 'Authorization': `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Cancel GST Invoice error:', error);
    throw error;
  }
};

// GST Rates APIs
export const getGSTRates = async (filters = {}, token) => {
  try {
    console.log("token ::::::::: ",token)
    const response = await api.get(gst_endpoint.gstRates_API, { 
      params: filters,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    console.log("response1 :::::::::::: ",response)
    return response.data;
  } catch (error) {
    console.error('Get GST Rates error:', error);
    throw error;
  }
};

export const createGSTRate = async (rateData, token) => {
  try {
    const response = await api.post(gst_endpoint.gstRates_API, rateData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Create GST Rate Error:", error);
    throw error;
  }
};

export const updateGSTRate = async (id, rateData, token) => {
  try {
    const response = await api.put(gst_endpoint.updateGSTRate(id), rateData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Update GST Rate Error:", error);
    throw error;
  }
};

export const deleteGSTRate = async (id, token) => {
  try {
    const response = await api.delete(gst_endpoint.deleteGSTRate(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Delete GST Rate Error:", error);
    throw error;
  }
};

export const getGSTRateById = async (id, token) => {
  try {
    const response = await api.get(gst_endpoint.getGSTRateById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Rate By ID Error:", error);
    throw error;
  }
};

export const getAllGSTRates = async (filters = {}, token) => {
  try {
    
    const { page = 1, limit = 50, taxType, serviceType, isActive } = filters;
    const params = { page, limit };
    if (taxType) params.taxType = taxType;
    if (serviceType) params.serviceType = serviceType;
    if (isActive !== undefined) params.isActive = isActive;
    console.log("token :::::::::: ",token)
    const response = await api.get(gst_endpoint.gstRates_API, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    console.log("response :::::::::: ",response)
    return response.data;
  } catch (error) {
    console.error("Get All GST Rates Error:", error);
    throw error;
  }
};

// GST Rates APIs
// export const getGSTRates = async (filters = {}) => {
//   try {
//     const response = await api.get(gst_endpoint.gstRates_API, { 
//       params: filters,
//       headers: getAuthHeaders()
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Get GST Rates error:', error);
//     if (error.response?.status === 401) {
//       window.location.href = '/login';
//     }
//     throw error;
//   }
// };

// export const createGSTRate = async (rateData, token) => {
//   try {
//     const response = await api.post(gst_endpoint.gstRates_API, rateData, {
//       headers: { 'Authorization': `Bearer ${token}` }
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Create GST Rate Error:", error);
//     throw error;
//   }
// };

// export const getAllGSTRates = async (token, filters = {}) => {
//   try {
//     const { page = 1, limit = 50, taxType, serviceType, isActive } = filters;
//     const params = { page, limit };
//     if (taxType) params.taxType = taxType;
//     if (serviceType) params.serviceType = serviceType;
//     if (isActive !== undefined) params.isActive = isActive;
    
//     const response = await api.get(gst_endpoint.gstRates_API, {
//       headers: { 'Authorization': `Bearer ${token}` },
//       params
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Get All GST Rates Error:", error);
//     throw error;
//   }
// };

// export const getGSTRateById = async (id, token) => {
//   try {
//     const response = await api.get(gst_endpoint.getGSTRateById(id), {
//       headers: { 'Authorization': `Bearer ${token}` }
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Get GST Rate By ID Error:", error);
//     throw error;
//   }
// };

// export const updateGSTRate = async (id, rateData, token) => {
//   try {
//     const response = await api.put(gst_endpoint.updateGSTRate(id), rateData, {
//       headers: { 'Authorization': `Bearer ${token}` }
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Update GST Rate Error:", error);
//     throw error;
//   }
// };

// export const deleteGSTRate = async (id, token) => {
//   try {
//     const response = await api.delete(gst_endpoint.deleteGSTRate(id), {
//       headers: { 'Authorization': `Bearer ${token}` }
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Delete GST Rate Error:", error);
//     throw error;
//   }
// };

export const getActiveGSTRates = async (token, serviceType = null) => {
  try {
    const params = serviceType ? { serviceType } : {};
    const response = await api.get(gst_endpoint.getActiveGSTRates, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("Get Active GST Rates Error:", error);
    throw error;
  }
};

// ========== BULK OPERATIONS ==========

export const bulkCreateGSTRates = async (rates, token) => {
  try {
    const response = await api.post(gst_endpoint.bulkCreateGSTRates, { rates }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Bulk Create GST Rates Error:", error);
    throw error;
  }
};

export const bulkUpdateGSTRates = async (updates, token) => {
  try {
    const response = await api.put(gst_endpoint.bulkUpdateGSTRates, { updates }, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Bulk Update GST Rates Error:", error);
    throw error;
  }
};

// ========== GST CONFIGURATION ==========

export const getGSTConfig = async (token) => {
  try {
    const response = await api.get(gst_endpoint.getGSTConfig, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Config Error:", error);
    throw error;
  }
};

export const updateGSTConfig = async (configData, token) => {
  try {
    const response = await api.put(gst_endpoint.updateGSTConfig, configData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Update GST Config Error:", error);
    throw error;
  }
};

// ========== HELPER APIS ==========

export const calculateGST = async (calculationData, token) => {
  try {
    const response = await api.post(gst_endpoint.calculateGST, calculationData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Calculate GST Error:", error);
    throw error;
  }
};

export const getCurrentRatesForService = async (serviceType, token, date = null) => {
  try {
    const params = date ? { date } : {};
    const response = await api.get(gst_endpoint.getCurrentRates(serviceType), {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("Get Current Rates Error:", error);
    throw error;
  }
};

// ========== REPORTS ==========

export const getGSTRateHistory = async (token, filters = {}) => {
  try {
    const { serviceType, taxType, startDate, endDate } = filters;
    const params = {};
    if (serviceType) params.serviceType = serviceType;
    if (taxType) params.taxType = taxType;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    const response = await api.get(gst_endpoint.getGSTRateHistory, {
      headers: { 'Authorization': `Bearer ${token}` },
      params
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Rate History Error:", error);
    throw error;
  }
};

export const getGSTSummary = async (token) => {
  try {
    const response = await api.get(gst_endpoint.getGSTSummary, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Get GST Summary Error:", error);
    throw error;
  }
};

// export const getAllMasterRoutes = async (token, page = 1, limit = 10, search = "") => {
//   try {
//     const response = await api.get(master_route_endpoint.masterRoutes_API, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       },
//       params: {
//         page,
//         limit,
//         search
//       }
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching master routes:', error);
//     throw error;
//   }
// };

// Get all master routes with filtering by source and destination
export const getAllMasterRoutes = async (token, page = 1, limit = 10, search = "", filters = {}) => {
  try {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...(search && { search }),
      ...(filters.source && { source: filters.source }),
      ...(filters.destination && { destination: filters.destination }),
      ...(filters.isActive !== undefined && { isActive: filters.isActive }),
      ...(filters.isRoundTrip !== undefined && { isRoundTrip: filters.isRoundTrip }),
      ...(filters.creatorType && { creatorType: filters.creatorType }),
      ...(filters.busOwner && { busOwner: filters.busOwner })
    });
    
    const response = await api.get(`/master-routes?${queryParams}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching master routes:", error);
    throw error;
  }
};

// Search master routes by source and destination
export const searchMasterRoutesBySourceDestination = async (token, source, destination) => {
  try {
    const response = await api.get(`/master-routes/search`, {
      params: { source, destination },
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error("Error searching master routes:", error);
    throw error;
  }
};

export const getMasterRouteById = async (routeId, token) => {
  try {
    const response = await api.get(master_route_endpoint.getMasterRouteById(routeId), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching master route:', error);
    throw error;
  }
};

export const createMasterRoute = async (routeData, token) => {
  try {
    const response = await api.post(master_route_endpoint.masterRoutes_API, routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating master route:', error);
    throw error;
  }
};

export const updateMasterRoute = async (routeId, routeData, token) => {
  try {
    const response = await api.put(master_route_endpoint.updateMasterRoute(routeId), routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating master route:', error);
    throw error;
  }
};

export const deleteMasterRoute = async (routeId, token) => {
  try {
    const response = await api.delete(master_route_endpoint.deleteMasterRoute(routeId), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting master route:', error);
    throw error;
  }
};

export const toggleMasterRouteStatus = async (routeId, isActive, token) => {
  try {
    const response = await api.patch(master_route_endpoint.toggleMasterRouteStatus(routeId), 
      { isActive },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling master route status:', error);
    throw error;
  }
};

// In ProductAPI.js
export const searchMasterRoutesByCitiesForForm = async (token, query, type = 'both') => {
  try {
    const response = await api.get(
      `/master-routes/source-destination-cities?query=${encodeURIComponent(query)}&type=${type}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error searching cities:", error);
    return { success: false, data: { suggestions: [] } };
  }
};

// Add this to your ProductAPI.js file
// Update your searchMasterRoutesByCities function
export const searchMasterRoutesByCities = async (token, source = '', destination = '') => {
  try {
    const params = {};
    if (source && source.trim()) params.source = source;
    if (destination && destination.trim()) params.destination = destination;
    
    console.log('Calling API with params:', params); // Debug log
    console.log('API URL:', master_route_endpoint.searchMasterRoutesByCities); // Debug log
    
    const response = await api.get(master_route_endpoint.searchMasterRoutesByCities, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params
    });
    console.log('API Response:', response.data); // Debug log
    return response.data;
  } catch (error) {
    console.error('Error searching master routes by cities:', error);
    console.error('Error response:', error.response); // Debug log
    throw error;
  }
};
// Admin Expense API Functions
export const getAdminExpenses = async (params, token) => {
  try {
    const response = await api.get(admin_expense_endpoint.adminExpenses_API, {
      params: params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSES_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseById = async (id, token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseById(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const createAdminExpense = async (expenseData, token) => {
  try {
    const response = await api.post(admin_expense_endpoint.adminExpenses_API, expenseData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("CREATE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const updateAdminExpense = async (id, expenseData, token) => {
  try {
    const response = await api.put(admin_expense_endpoint.updateAdminExpense(id), expenseData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("UPDATE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const deleteAdminExpense = async (id, token) => {
  try {
    const response = await api.delete(admin_expense_endpoint.deleteAdminExpense(id), {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("DELETE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const approveAdminExpense = async (id, approvalData, token) => {
  try {
    const response = await api.patch(admin_expense_endpoint.approveAdminExpense(id), approvalData, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("APPROVE_ADMIN_EXPENSE_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseCategories = async (token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseCategories, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_CATEGORIES_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseDepartments = async (token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseDepartments, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_DEPARTMENTS_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminExpenseStats = async (params, token) => {
  try {
    const response = await api.get(admin_expense_endpoint.getAdminExpenseStats, {
      params: params,
      headers: { 'Authorization': `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_EXPENSE_STATS_API_ERROR..........", error);
    throw error;
  }
};


export const getBusIncome = async (busId, params, token) => {
  try {
    console.log("Fetching bus income with params:", params);
    const response = await api.get(getBusIncomeEndpoint(busId), {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Income API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BUS_INCOME_API_ERROR..........", error);
    throw error;
  }
};

export const getAllBusesIncome = async (params, token) => {
  try {
    console.log("Fetching all buses income with params:", params);
    const response = await api.get(getAllBusesIncomeEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("All Buses Income API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_ALL_BUSES_INCOME_API_ERROR..........", error);
    throw error;
  }
};

export const getBusIncomeSummary = async (params, token) => {
  try {
    console.log("Fetching bus income summary with params:", params);
    const response = await api.get(getBusIncomeSummaryEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Income Summary API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BUS_INCOME_SUMMARY_API_ERROR..........", error);
    throw error;
  }
};

export const processCommissionPayment = async (ownerId, paymentData, token) => {
  try {
    // Call the endpoint function with the ownerId variable
    const url = processCommissionPaymentEndpoint(ownerId); 
    
    const response = await api.post(url, paymentData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const getCommissionPaymentHistory = async (ownerId, token, page = 1, limit = 10) => {
  try {
    // Call the endpoint function with the ownerId
    const url = commission_endpoint.getCommissionPaymentHistory(ownerId);
    console.log('Get Payment History URL:', url);
    
    const response = await api.get(url, {
      params: { page, limit },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Get Payment History Error:', error);
    throw error.response?.data || error.message;
  }
};

// Get all commission payments (admin)
export const getAllCommissionPayments = async (token, filters = {}) => {
  try {
    // This is a string, not a function
    const url = commission_endpoint.getAllCommissionPayments;
    console.log('Get All Payments URL:', url);
    
    const response = await api.get(url, {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Get All Payments Error:', error);
    throw error.response?.data || error.message;
  }
};

// Update commission payment status
export const updatePaymentStatus = async (paymentId, status, token) => {
  try {
    // Call the endpoint function with the paymentId
    const url = commission_endpoint.updatePaymentStatus(paymentId);
    console.log('Update Payment Status URL:', url);
    
    const response = await api.put(url, 
      { status },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Update Payment Status Error:', error);
    throw error.response?.data || error.message;
  }
};

// Get all freelancers with pagination and filters
export const getFreelancers = async (token, page = 1, limit = 10, search = '', status = '', approval = '') => {
  try {
    let url = `${freelancers_API}?page=${page}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    if (status) url += `&status=${status}`;
    if (approval) url += `&approval=${approval}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching freelancers:', error);
    throw error;
  }
};

// Get freelancer by ID
export const getFreelancerById = async (freelancerId, token) => {
  try {
    const url = typeof getFreelancerByIdEndpoint === 'function' 
      ? getFreelancerByIdEndpoint(freelancerId) 
      : `${freelancers_API}/${freelancerId}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching freelancer by ID:', error);
    throw error;
  }
};

// Create new freelancer
export const createFreelancer = async (freelancerData, token) => {
  try {
    const response = await api.post(freelancers_API, freelancerData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating freelancer:', error);
    throw error;
  }
};

// Update freelancer
export const updateFreelancer = async (freelancerId, updateData, token) => {
  try {
    const url = typeof updateFreelancerEndpoint === 'function'
      ? updateFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}`;
    
    const response = await api.put(url, updateData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating freelancer:', error);
    throw error;
  }
};

// Update password
export const updateFreelancerPassword = async (freelancerId, passwordData, token) => {
  try {
    const url = typeof updateFreelancerPasswordEndpoint === 'function'
      ? updateFreelancerPasswordEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/reset-password`;
    
    const response = await api.post(url, passwordData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating freelancer password:', error);
    throw error;
  }
};

// Soft delete freelancer
export const deleteFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof deleteFreelancerEndpoint === 'function'
      ? deleteFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting freelancer:', error);
    throw error;
  }
};

// Permanent delete freelancer
export const permanentDeleteFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof permanentDeleteFreelancerEndpoint === 'function'
      ? permanentDeleteFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/permanent`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error permanently deleting freelancer:', error);
    throw error;
  }
};

// Bulk create freelancers
export const bulkCreateFreelancers = async (freelancersData, token) => {
  try {
    const response = await api.post(bulkCreateFreelancersEndpoint, { freelancers: freelancersData }, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error bulk creating freelancers:', error);
    throw error;
  }
};

// Approve freelancer
export const approveFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof approveFreelancerEndpoint === 'function'
      ? approveFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/approve`;
    
    const response = await api.patch(url, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error approving freelancer:', error);
    throw error;
  }
};

// Reject freelancer
export const rejectFreelancer = async (freelancerId, token) => {
  try {
    const url = typeof rejectFreelancerEndpoint === 'function'
      ? rejectFreelancerEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/reject`;
    
    const response = await api.patch(url, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error rejecting freelancer:', error);
    throw error;
  }
};

// Toggle freelancer status
export const toggleFreelancerStatus = async (freelancerId, token) => {
  try {
    const url = typeof toggleFreelancerStatusEndpoint === 'function'
      ? toggleFreelancerStatusEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/toggle-status`;
    
    const response = await api.patch(url, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error toggling freelancer status:', error);
    throw error;
  }
};

// Update freelancer permissions
export const updateFreelancerPermissions = async (freelancerId, permissions, token) => {
  try {
    const url = typeof updatePermissionsEndpoint === 'function'
      ? updatePermissionsEndpoint(freelancerId)
      : `${freelancers_API}/${freelancerId}/permissions`;
    
    const response = await api.put(url, { permissions }, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating freelancer permissions:', error);
    throw error;
  }
};

// Get freelancer stats
export const getFreelancerStats = async (token) => {
  try {
    const response = await api.get(getFreelancerStatsEndpoint, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching freelancer stats:', error);
    throw error;
  }
};

// Get all employees with pagination and filters
export const getEmployees = async (token, page = 1, limit = 10, search = '', role = '', department = '', status = '') => {
  try {
    let url = `${employees_API}?page=${page}&limit=${limit}&search=${search}`;
    if (role) url += `&role=${role}`;
    if (department) url += `&department=${department}`;
    if (status) url += `&isActive=${status === 'active'}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching employees:', error);
    throw error;
  }
};

// Get employee by ID
export const getEmployeeById = async (employeeId, token) => {
  try {
    const url = typeof getEmployeeByIdEndpoint === 'function' 
      ? getEmployeeByIdEndpoint(employeeId) 
      : `${employees_API}/${employeeId}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching employee by ID:', error);
    throw error;
  }
};

// Create new employee
export const createEmployee = async (employeeData, token) => {
  try {
    const response = await api.post(employees_API, employeeData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating employee:', error);
    throw error;
  }
};

// Update employee
export const updateEmployee = async (employeeId, updateData, token) => {
  try {
    const url = typeof updateEmployeeEndpoint === 'function'
      ? updateEmployeeEndpoint(employeeId)
      : `${employees_API}/${employeeId}`;
    
    const response = await api.put(url, updateData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating employee:', error);
    throw error;
  }
};

// Update password
export const updateEmployeePassword = async (employeeId, passwordData, token) => {
  try {
    const url = typeof updatePasswordEndpoint === 'function'
      ? updatePasswordEndpoint(employeeId)
      : `${employees_API}/${employeeId}/password`;
    
    const response = await api.put(url, passwordData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating employee password:', error);
    throw error;
  }
};

// Soft delete employee
export const deleteEmployee = async (employeeId, token) => {
  try {
    const url = typeof deleteEmployeeEndpoint === 'function'
      ? deleteEmployeeEndpoint(employeeId)
      : `${employees_API}/${employeeId}`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting employee:', error);
    throw error;
  }
};

// Permanent delete employee
export const permanentDeleteEmployee = async (employeeId, token) => {
  try {
    const url = typeof permanentDeleteEmployeeEndpoint === 'function'
      ? permanentDeleteEmployeeEndpoint(employeeId)
      : `${employees_API}/${employeeId}/permanent`;
    
    const response = await api.delete(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error permanently deleting employee:', error);
    throw error;
  }
};

// Bulk create employees
export const bulkCreateEmployees = async (employeesData, token) => {
  try {
    const response = await api.post(bulkCreateEmployeesEndpoint, { employees: employeesData }, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error bulk creating employees:', error);
    throw error;
  }
};

// ============ BUS MANAGEMENT APIs ============

// Get bus routes
export const getBusRoutes = async (token, page = 1, limit = 10, search = '', ownerId = null) => {
  try {
    let url = `${route_API}?page=${page}&limit=${limit}&search=${search}`;
    if (ownerId) {
      url += `&ownerId=${ownerId}`;
    }
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bus routes:', error);
    throw error;
  }
};

// Get bus by ID
// export const getBusById = async (busId, token) => {
//   try {
//     const response = await api.get(`/buses/${busId}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching bus by ID:', error);
//     throw error;
//   }
// };

// Delete bus
export const deleteBus = async (busId, token) => {
  try {
    const response = await api.delete(`/buses/${busId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting bus:', error);
    throw error;
  }
};

// Update bus
export const updateBus = async (busId, formData, token) => {
  try {
    const response = await api.put(`/buses/${busId}`, formData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating bus:', error);
    throw error;
  }
};

// Get all buses (admin)
export const getAllBuses = async (token, params = {}) => {
  try {
    const { page = 1, limit = 10, search = '', busType = '', busCategory = '', status = '' } = params;
    let url = `/buses?page=${page}&limit=${limit}&search=${search}&busType=${busType}&busCategory=${busCategory}&status=${status}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching all buses:', error);
    throw error;
  }
};

// Get bus statistics (admin)
export const getBusStats = async (token) => {
  try {
    const response = await api.get('/buses/stats', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bus stats:', error);
    throw error;
  }
};

export const deleteDriver = async (driverId, token) => {
  try {
    const response = await api.delete(
      `${drivers_API}/${driverId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting driver:', error);
    throw error;
  }
};

// Delete Conductor
export const deleteConductor = async (conductorId, token) => {
  try {
    const response = await api.delete(
      `${conductors_API}/${conductorId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting conductor:', error);
    throw error;
  }
};


// ============ DRIVER MANAGEMENT APIs ============

// Get all drivers (admin view)
export const getAllDrivers = async (token, page = 1, limit = 10, search = '') => {
  try {
    const response = await api.get(`${drivers_endpoint.drivers_API}?page=${page}&limit=${limit}&search=${search}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching drivers:', error);
    throw error;
  }
};

export const addDriver = async (driverData, token) => {
  try {
    const response = await api.post(
      drivers_API,
      driverData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding driver:', error);
    throw error;
  }
};

export const addConductor = async (conductorData, token) => {
  try {
    const response = await api.post(
      conductors_API,
      conductorData,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error adding conductor:', error);
    throw error;
  }
};


// Get drivers by bus owner
export const getDriversByBusOwner = async (busOwnerId, token, params = {}) => {
  try {
    const { page = 1, limit = 10, assigned, search } = params;
    let url = `${drivers_API}/busowner/${busOwnerId}?page=${page}&limit=${limit}`;
    if (assigned !== undefined) url += `&assigned=${assigned}`;
    if (search) url += `&search=${search}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching drivers by bus owner:', error);
    throw error;
  }
};

// Assign driver to bus
export const assignDriverToBus = async (driverId, busId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${drivers_API}/${driverId}/assign/${busId}`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error assigning driver to bus:', error);
    throw error;
  }
};

// Unassign driver from bus
export const unassignDriverFromBus = async (driverId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${drivers_API}/${driverId}/unassign`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error unassigning driver from bus:', error);
    throw error;
  }
};

// ============ CONDUCTOR MANAGEMENT APIs ============

// Get all conductors (admin view)
export const getAllConductors = async (token, page = 1, limit = 10, search = '') => {
  try {
    const response = await api.get(`${conductors_endpoint.conductors_API}?page=${page}&limit=${limit}&search=${search}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching conductors:', error);
    throw error;
  }
};

// Get conductors by bus owner
export const getConductorsByBusOwner = async (busOwnerId, token, params = {}) => {
  try {
    const { page = 1, limit = 10, assigned, search } = params;
    let url = `${conductors_API}/busowner/${busOwnerId}?page=${page}&limit=${limit}`;
    if (assigned !== undefined) url += `&assigned=${assigned}`;
    if (search) url += `&search=${search}`;
    
    const response = await api.get(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching conductors by bus owner:', error);
    throw error;
  }
};

// Assign conductor to bus
export const assignConductorToBus = async (conductorId, busId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${conductors_API}/${conductorId}/assign/${busId}`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error assigning conductor to bus:', error);
    throw error;
  }
};

// Unassign conductor from bus
export const unassignConductorFromBus = async (conductorId, busOwnerId, token) => {
  try {
    const response = await api.post(
      `${conductors_API}/${conductorId}/unassign`,
      { busOwnerId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error unassigning conductor from bus:', error);
    throw error;
  }
};

// Get available (unassigned) drivers for a bus owner
export const getAvailableDrivers = async (busOwnerId, token, search = '') => {
  try {
    const response = await api.get(
      `${conductors_API}/busowner/${busOwnerId}?assigned=false&search=${search}&limit=50`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching available drivers:', error);
    throw error;
  }
};

// Get available (unassigned) conductors for a bus owner
export const getAvailableConductors = async (busOwnerId, token, search = '') => {
  try {
    const response = await api.get(
      `${conductors_API}/busowner/${busOwnerId}?assigned=false&search=${search}&limit=50`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching available conductors:', error);
    throw error;
  }
};

// In your ProductAPI.js file, make sure you have this export
// export const getAllCategory = async (token) => {
//   try {
//     const response = await api.get('/categories', {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching categories:', error);
//     throw error;
//   }
// };

export const getAllCategory = async (token, busCategory = null) => {
  try {
    // Build the URL with query parameters
    let url = '/categories';
    if (busCategory) {
      url += `?busCategory=${encodeURIComponent(busCategory)}`;
    }
    
    const response = await api.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// Add this function to your ProductAPI.js file
export const getSeatLayoutsByBustype = async (bustype, token) => {
  try {
    const response = await api.get(`/layouts/bustype/${bustype}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching seat layouts:', error);
    throw error;
  }
};


export const getSeatLayouts = async (busType, token) => {
  try {
    console.log('Fetching seat layouts for bus type:', busType);
   
    // Use the function from api_endpoints
    const url = admin_layout_endpoint.getLayoutsByBusType(busType);
    
    console.log('Request URL:', url);
    
    const response = await api.get(url, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching seat layouts:', error);
    console.error('Error details:', error.response?.data || error.message);
    
    // Return a standardized error response
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to fetch seat layouts',
      data: []
    };
  }
};


// Request password reset (send OTP)
export const forgotPassword = async (email) => {
  try {
    const response = await api.post(forgotPassword_API, { email });
    return response.data;
  } catch (error) {
    console.error('Forgot password error:', error);
    throw error.response?.data || error;
  }
};

// Verify OTP
export const verifyOtp = async (email, otp) => {
  try {
    const response = await api.post(verifyOtp_API, { email, otp });
    return response.data;
  } catch (error) {
    console.error('Verify OTP error:', error);
    throw error.response?.data || error;
  }
};

// Reset password
export const resetPassword = async (resetToken, email, password, confirmPassword) => {
  try {
    const response = await api.post(resetPassword_API, {
      resetToken,
      email,
      password,
      confirmPassword
    });
    return response.data;
  } catch (error) {
    console.error('Reset password error:', error);
    throw error.response?.data || error;
  }
};

// Resend OTP
export const resendOtp = async (email) => {
  try {
    const response = await api.post(resendOtp_API, { email });
    return response.data;
  } catch (error) {
    console.error('Resend OTP error:', error);
    throw error.response?.data || error;
  }
};

// In ProductAPI.js - FIXED for FormData
export const addBusToOwner = async (ownerId, busData, token) => {
  try {
    console.log('Owner ID received:', ownerId);
    console.log('Type of ownerId:', typeof ownerId);
    
    // IMPORTANT: Call the function with parentheses
    const url = addBusToOwnerApi(ownerId); // ADD PARENTHESES!
    console.log('Generated URL:', url);
    
    const response = await api.post(
      url, // Use the URL returned by the function
      busData,
      {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data' // IMPORTANT: Set to multipart/form-data
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error adding bus:', error);
    console.error('Error details:', error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

// In your ProductAPI.js or wherever you have your API functions
// export const getAllBusownerAdminRoutes = async (token, page = 1, limit = 10, search = '', busOwnerId = '') => {
//   try {
//     const params = new URLSearchParams({
//       page: page.toString(),
//       limit: limit.toString(),
//       ...(search && { search }),
//       ...(busOwnerId && { busOwnerId }) // Add busOwnerId parameter
//     });

//    const response = await api.get(`${route_API}/busowner?${params}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching routes:', error);
//     throw error;
//   }
// };

// In your ProductAPI.js
export const getAllBusownerAdminRoutes = async (token, page = 1, limit = 10, search = '', busOwnerId = '', filters = {}, localRouteName = '') => {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(search && { search }),
      ...(busOwnerId && { busOwnerId }),
      ...(filters.originCity && { originCity: filters.originCity }),
      ...(filters.destinationCity && { destinationCity: filters.destinationCity }),
      ...(localRouteName && { localRouteName })  // ← NEW
    });

    const response = await api.get(`${route_API}/busowner?${params}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching routes:', error);
    throw error;
  }
};

export const getAllSeatCategories = async (token, page = 1, pageSize = 10, search = '') => {
  try {
    const response = await api.get(`${getAllCategories}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit: pageSize, search }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSeatCategoryById = async (id, token) => {
  try {
    const response = await api.get(`${getAllCategories}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createSeatCategory = async (categoryData, token) => {
  try {
    const response = await api.post(`${getAllCategories}`, categoryData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateSeatCategory = async (id, categoryData, token) => {
  try {
    const response = await api.put(`${getAllCategories}/${id}`, categoryData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSeatCategory = async (id, token) => {
  try {
    const response = await api.delete(`${getAllCategories}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    console.log("response.data : ",response.data)
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Seat Layouts APIs
export const getAllSeatLayouts = async (token, page = 1, pageSize = 10, search = '') => {
  try {
    const response = await api.get(`${getAllLayout}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit: pageSize, search }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSeatLayoutById = async (id, token) => {
  try {
    const response = await api.get(`${getAllLayout}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createSeatLayout = async (layoutData, token) => {
  try {
    const response = await api.post(`${getAllLayout}`, layoutData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateSeatLayout = async (id, layoutData, token) => {
  try {
    const response = await api.put(`${getAllLayout}/${id}`, layoutData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSeatLayout = async (id, token) => {
  try {
    const response = await api.delete(`${getAllLayout}/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Preview Layout
export const previewSeatLayout = async (previewData, token) => {
  try {
    const response = await api.post(`${getAllLayout}/preview`, previewData, {
      headers: { 
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Layouts by Category
export const getLayoutsByCategory = async (categoryId, token) => {
  try {
    const response = await api.get(`${getAllLayout}/${categoryId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get available configurations
export const getAvailableConfigurations = async (token) => {
  try {
    const response = await api.get(`${getAllLayout}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get all terms and conditions
export const getAllTerms = async (token, page = 1, limit = 10, type = "") => {
  try {
    const response = await api.get(`${getAllTerm}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      params: {
        page,
        limit,
        type
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms:', error);
    throw error;
  }
};
export const getTermsById = async (id, token) => {
  try {
    const response = await api.get(`${getAllTerm}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms by ID:', error);
    throw error;
  }
};
// Get terms by type
export const getTermsByType = async (type, token) => {
  try {
    const response = await api.get(`${getAllTerm}/type/${type}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms by type:', error);
    throw error;
  }
};

// Create new terms
export const createTerms = async (termsData, token) => {
  try {
    const response = await api.post(`${getAllTerm}`, termsData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating terms:', error);
    throw error;
  }
};

// Update existing terms
export const updateTerms = async (id, termsData, token) => {
  try {
    const response = await api.put(`${getAllTerm}/${id}`, termsData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating terms:', error);
    throw error;
  }
};

// Toggle terms status (activate/deactivate)
export const toggleTermsStatus = async (id, token) => {
  try {
    const response = await api.patch(`${getAllTerm}/${id}/toggle-status`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error toggling terms status:', error);
    throw error;
  }
};

// Get terms history
export const getTermsHistory = async (id, token) => {
  try {
    const response = await api.get(`${getAllTerm}/${id}/history`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching terms history:', error);
    throw error;
  }
};

// export const getAllRoutes = async (token, page = 1, limit = 10, search = "") => {
//   try {
//     const response = await api.get(`${route_API}`, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       },
//       params: {
//         page,
//         limit,
//         search
//       }
//     });
//     return response.data;
//   } catch (error) {
//     console.error('Error fetching routes:', error);
//     throw error;
//   }
// };
export const getAllRoutes = async (token, page = 1, limit = 10, search = "", origin = "", destination = "") => {
    try {
        const params = {
            page,
            limit
        };
        
        if (search) params.search = search;
        if (origin) params.origin = origin;
        if (destination) params.destination = destination;
        
        const response = await api.get(`${route_API}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            params
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching routes:', error);
        throw error;
    }
};

export const getRouteById = async (routeId, token) => {
  try {
    const response = await api.get(`${route_API}/${routeId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching route:', error);
    throw error;
  }
};
export const createRoute = async (routeData, token) => {
  try {
    const response = await api.post(`${route_API}`, routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error creating route:', error);
    throw error;
  }
};
export const updateRoute = async (routeId, routeData, token) => {
  try {
    const response = await api.put(`${route_API}/${routeId}`, routeData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error updating route:', error);
    throw error;
  }
};
export const deleteRoute = async (routeId, token) => {
  try {
    const response = await api.delete(`${route_API}/${routeId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting route:', error);
    throw error;
  }
};
export const toggleRouteStatus = async (routeId, isActive, token) => {
  try {
    const response = await api.patch(`${route_API}/${routeId}/status`, 
      { isActive },
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error toggling route status:', error);
    throw error;
  }
};
export const getMasterRouteByName = async (masterRouteName, token) => {
  try {
    const response = await api.get(`${master_route_endpoint.masterRoutes_API}/name/${encodeURIComponent(masterRouteName)}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching master route by name:', error);
    throw error;
  }
};
export const getInfluencerCommissions = async (token, params = {}) => {
  try {
    const response = await api.get(getInfluencerCommissionsEndpoint, {
      params, // ✅ THIS WAS MISSING
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error("GET_INFLUENCER_COMMISSIONS_API_ERROR", error);
    throw error;
  }
};



// Also update getCommissionStats to accept params
export const getCommissionStats = async (token, params = {}) => {
  try {
    const response = await api.get(getCommissionStatsEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log("GET_COMMISSION_STATS_API_ERROR..........", error);
    throw error;
  }
};

// export const getCommissionStats = async (token) => {
//   try {
//     console.log("Fetching commission stats...");
//     const response = await api.get(`${getCommissionStatsEndpoint}`, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       }
//     });
//     console.log("Commission Stats Response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.log("GET_COMMISSION_STATS_API_ERROR..........", error);
//     throw error;
//   }
// };

export const getCommissionById = async (id, token) => {
  try {
    console.log(`Fetching commission with ID: ${id}`);
    const response = await api.get(`${getCommissionByIdEndpoint}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Commission by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_COMMISSION_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const processBulkPayout = async (data, token) => {
  try {
    console.log("Processing bulk payout...", data);
    const response = await api.post(`${processBulkPayoutEndpoint}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bulk Payout Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("PROCESS_BULK_PAYOUT_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencers = async (token, params = {}) => {
  try {
    console.log("Fetching influencers with params:", params);
    const response = await api.get(influencers_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencers API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCERS_API_ERROR..........", error);
    throw error;
  }
};

export const getInfluencerById = async (id, token) => {
  try {
    console.log(`Fetching influencer with ID: ${id}`);
    const response = await api.get(`${influencers_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Influencer by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_INFLUENCER_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateInfluencer = async (id, data, token) => {
  try {
    console.log(`Updating influencer with ID: ${id}`, data);
    const response = await api.put(`${influencers_API}/${id}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Influencer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_INFLUENCER_API_ERROR..........", error);
    throw error;
  }
};

export const deleteInfluencer = async (id, token) => {
  try {
    console.log(`Deleting influencer with ID: ${id}`);
    const response = await api.delete(`${influencers_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Influencer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_INFLUENCER_API_ERROR..........", error);
    throw error;
  }
};

export const updateInfluencerStatus = async (id, data, token) => {
  try {
    console.log(`Updating influencer status for ID: ${id}`, data);
    const response = await api.patch(`${influencers_API}/${id}/status`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Influencer Status Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_INFLUENCER_STATUS_API_ERROR..........", error);
    throw error;
  }
};

export const getAdminProfile = async (token) => {
  try {
    console.log("Fetching admin profile...");
    const response = await api.get(getAdminProfileEndpoint, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Admin Profile Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_ADMIN_PROFILE_API_ERROR..........", error);
    throw error;
  }
};

export const updateAdminProfile = async (data, token) => {
  try {
    console.log("Updating admin profile...", data);
    
    // Check if data is FormData (for file upload) or regular object
    const isFormData = data instanceof FormData;
    
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    };

    // Set appropriate content type
    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json';
    }

    const response = await api.put(updateAdminProfileEndpoint, data, config);
    console.log("Update Admin Profile Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_ADMIN_PROFILE_API_ERROR..........", error);
    throw error;
  }
};

export const changeAdminPassword = async (data, token) => {
  try {
    console.log("Changing admin password...", data);
    const response = await api.put(changeAdminPasswordEndpoint, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Change Password Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CHANGE_ADMIN_PASSWORD_API_ERROR..........", error);
    throw error;
  }
};

export const updateAdminSettings = async (data, token) => {
  try {
    console.log("Updating admin settings...", data);
    const response = await api.put(updateAdminSettingsEndpoint, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Admin Settings Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_ADMIN_SETTINGS_API_ERROR..........", error);
    throw error;
  }
};

export const getPayments = async (params, token) => {
  try {
    console.log("Fetching payments with params:", params);
    const response = await api.get(payments_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Payments API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_PAYMENTS_API_ERROR..........", error);
    throw error;
  }
};

export const getPaymentById = async (id, token) => {
  try {
    console.log(`Fetching payment with ID: ${id}`);
    const response = await api.get(getPaymentByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Payment by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_PAYMENT_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const processPayment = async (id, token) => {
  try {
    console.log(`Processing payment with ID: ${id}`);
    const response = await api.put(processPaymentEndpoint(id), {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Process Payment Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("PROCESS_PAYMENT_API_ERROR..........", error);
    throw error;
  }
};

export const refundPayment = async (id, refundData, token) => {
  try {
    console.log(`Refunding payment with ID: ${id}`, refundData);
    const response = await api.put(refundPaymentEndpoint(id), refundData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Refund Payment Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("REFUND_PAYMENT_API_ERROR..........", error);
    throw error;
  }
};

// export const getCoupons = async (token) => {
//   try {
//     console.log("Fetching coupons...");
//     const response = await api.get(coupons_API, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       }
//     });
//     console.log("Coupons API Response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.log("GET_COUPONS_API_ERROR..........", error);
//     throw error;
//   }
// };
export const getCoupons = async (token, params = {}) => {
  try {
    console.log("Fetching coupons with params:", params);
    const response = await api.get(coupons_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Coupons API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_COUPONS_API_ERROR..........", error);
    throw error;
  }
};
export const getCouponById = async (id, token) => {
  try {
    console.log(`Fetching coupon with ID: ${id}`);
    const response = await api.get(getCouponByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Coupon by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_COUPON_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const createCoupon = async (data, token) => {
  try {
    console.log("Creating new coupon...", data);
    const response = await api.post(coupons_API, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Coupon Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_COUPON_API_ERROR..........", error);
    throw error;
  }
};

export const updateCoupon = async (id, data, token) => {
  try {
    console.log(`Updating coupon with ID: ${id}`, data);
    const response = await api.put(updateCouponEndpoint(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Coupon Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_COUPON_API_ERROR..........", error);
    throw error;
  }
};

export const deleteCoupon = async (id, token) => {
  try {
    console.log(`Deleting coupon with ID: ${id}`);
    const response = await api.delete(deleteCouponEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Coupon Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_COUPON_API_ERROR..........", error);
    throw error;
  }
};


// export const getBusOwners = async (token) => {
//   try {
//     console.log("Fetching bus owners...");
//     const response = await api.get(busOwners_API, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       }
//     });
//     console.log("Bus Owners API Response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.log("GET_BUS_OWNERS_API_ERROR..........", error);
//     throw error;
//   }
// };

// Services/Operations/ProductAPI.js
export const getBusOwners = async (token, page = 1, limit = 10, search = "") => {
  try {
    const response = await api.get(busOwners_API, {
      params: { 
        page,
        limit,
        search // Send search term to backend
      },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log("GET_BUS_OWNERS_API_ERROR..........", error);
    throw error;
  }
};

export const getBookingsByDateAndBus = async (token, busId, date) => {
  try {
    console.log('📡 Calling API with:', { busId, date });
    
    const response = await api.get(bookingFilter_API, {
      params: {
        busId: busId,
        date: date // 'YYYY-MM-DD' format
      },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('📦 API Response:', response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BOOKINGS_BY_DATE_API_ERROR..........", error);
    console.error('Error details:', error.response?.data || error.message);
    throw error;
  }
};

export const getBusSeatAvailability = async (token, busId, date, direction, timeSlot) => {
  try {
    console.log('📡 Calling seat availability API with:', { busId, date, direction, timeSlot });
    
    const response = await api.get('/bus-seat-availability', {
      params: {
        busId: busId,
        date: date,
        direction: direction,
        timeSlot: timeSlot || 1
      },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log('📦 Seat availability response:', response.data);
    return response.data;
  } catch (error) {
    console.log("GET_SEAT_AVAILABILITY_API_ERROR..........", error);
    console.error('Error details:', error.response?.data || error.message);
    throw error;
  }
};

export const getBusOwnerById = async (id, token) => {
  try {
    console.log(`Fetching bus owner with ID: ${id}`);
    const response = await api.get(getBusOwnerByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Owner by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BUS_OWNER_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const approveBusOwner = async (id, token) => {
  try {
   console.log("token : ", token);
    const response = await api.patch(approvedBusOwnerById(id), 
      {}, 
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error approving bus owner:', error);
    throw error;
  }
};

export const createBusOwner = async (data, token) => {
  try {
    console.log("Creating new bus owner...", data);
    const response = await api.post(busOwners_API, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Bus Owner Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_BUS_OWNER_API_ERROR..........", error);
    throw error;
  }
};
export const updateBusOwner = async (id, data, token) => {
  try {
    console.log(`Updating bus owner with ID: ${id}`, data);
    
    // Make sure the endpoint is correct
    const response = await api.put(`/bus-owners/${id}`, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    
    console.log("Update Bus Owner Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("UPDATE_BUS_OWNER_API_ERROR..........", error);
    throw error;
  }
};

export const deleteBusOwner = async (id, token) => {
  try {
    console.log(`Deleting bus owner with ID: ${id}`);
    const response = await api.delete(deleteBusOwnerEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Delete Bus Owner Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("DELETE_BUS_OWNER_API_ERROR..........", error);
    throw error;
  }
};

// Customer API functions
// export const getCustomers = async (token) => {
//   try {
//     console.log("Fetching customers...");
//     const response = await api.get(customersEndpoint, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'application/json'
//       }
//     });
//     console.log("Customers API Response:", response.data);
//     return response.data;
//   } catch (error) {
//     console.log("GET_CUSTOMERS_API_ERROR..........", error);
//     throw error;
//   }
// };
// Services/Operations/ProductAPI.js
export const getCustomers = async (token, page = 1, limit = 10, search = "") => {
  try {
    const response = await api.get(customersEndpoint, {
      params: { 
        page,
        limit,
        search // Pass the search term to the backend
      },
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getCustomerById = async (id, token) => {
  try {
    console.log(`Fetching customer with ID: ${id}`);
    const response = await api.get(getCustomerByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Customer by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_CUSTOMER_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateCustomer = async (id, data, token) => {
  try {
    console.log(`Updating customer with ID: ${id}`, data);
    const response = await api.put(updateCustomerEndpoint(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Customer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_CUSTOMER_API_ERROR..........", error);
    throw error;
  }
};

export const login_data = async (data) => {
  try {
    console.log("Login API Call Started...");
    const response = await api.post(login_API, data);
    console.log("Login API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_login_API_ERROR..........", error);
    throw error;
  }
};

export const getDashboardStats = async (token) => {
  try {
    console.log("Dashboard Stats API Call Started...");
    const response = await api.get(dashboard_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Dashboard Stats API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_dashboard_API_ERROR..........", error);
    throw error;
  }
};

export const getUsers = async (token) => {
  try {
    console.log("Users API Call Started...");
    const response = await api.get(users_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Users API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_users_API_ERROR..........", error);
    throw error;
  }
};

export const getDrivers = async (token, page = 1, limit = 10, search = '') => {
  try {
    console.log("Drivers API Call Started...");
    
    // Build query parameters
    const params = {};
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    
    const response = await api.get(drivers_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: params  // This sends query parameters
    });
    
    console.log("Drivers API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_drivers_API_ERROR..........", error);
    throw error;
  }
};

export const getConductors = async (token, page = 1, limit = 10, search = '') => {
  try {
      const params = {};
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    
    console.log("Conductors API Call Started...");
    const response = await api.get(conductors_API, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: params  // This sends query parameters
    });
    console.log("Conductors API Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_conductors_API_ERROR..........", error);
    throw error;
  }
};

export const getDriverById = async (id, token) => {
  try {
    console.log(`Fetching driver with ID: ${id}`);
    const response = await api.get(`${drivers_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Driver Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_driver_by_ID_API_ERROR..........", error);
    throw error;
  }
};

// Update driver
export const updateDriver = async (id, driverData, token) => {
  try {
    console.log(`Updating driver with ID: ${id}`, driverData);
    const response = await api.put(`${drivers_API}/${id}`, driverData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Driver Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_driver_API_ERROR..........", error);
    throw error;
  }
};

export const getConductorById = async (id, token) => {
  try {
    console.log(`Fetching conductor with ID: ${id}`);
    const response = await api.get(`${conductors_API}/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    console.log("Conductor Details Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_conductor_by_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateConductor = async (id, conductorData, token) => {
  try {
    console.log(`Updating conductor with ID: ${id}`, conductorData);
    const response = await api.put(`${conductors_API}/${id}`, conductorData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Conductor Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_conductor_API_ERROR..........", error);
    throw error;
  }
};

export const getBookings = async (token, params = {}) => {
  try {
    const response = await api.get(bookings_API, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.log("GET_BOOKINGS_API_ERROR..........", error);
    throw error;
  }
};

export const getBookingById = async (id, token) => {
  try {
    console.log(`Fetching booking with ID: ${id}`);
    const response = await api.get(getBookingByIdEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Booking by ID Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("GET_BOOKING_BY_ID_API_ERROR..........", error);
    throw error;
  }
};

export const updateBooking = async (id, data, token) => {
  try {
    console.log(`Updating booking with ID: ${id}`, data);
    const response = await api.put(updateBookingEndpoint(id), data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Booking Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_BOOKING_API_ERROR..........", error);
    throw error;
  }
};

export const updateBookingStatus = async (id, statusData, token) => {
  try {
    console.log(`Updating booking status for ID: ${id}`, statusData);
    const response = await api.patch(updateBookingStatusEndpoint(id), statusData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Booking Status Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("UPDATE_BOOKING_STATUS_API_ERROR..........", error);
    throw error;
  }
};

export const getCommissionReports = async (params, token) => {
  try {
    console.log("Fetching commission reports with params:", params);
    const response = await api.get(getCommissionReportsEndpoint, {
      params: params,
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Commission Reports Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("GET_COMMISSION_REPORTS_API_ERROR..........", error);
    throw error;
  }
};

export const getBusOwnerCommission = async (id, token) => {
  try {
    console.log(`Fetching commission for bus owner ID: ${id}`);
    const response = await api.get(getBusOwnerCommissionEndpoint(id), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Bus Owner Commission Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("GET_BUS_OWNER_COMMISSION_API_ERROR..........", error);
    throw error;
  }
};

export const updateBusOwnerCommission = async (id, commissionData, token) => {
  try {
    console.log(`Updating commission for bus owner ID: ${id}`, commissionData);
    const response = await api.put(updateBusOwnerCommissionEndpoint(id), commissionData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Update Commission Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("UPDATE_BUS_OWNER_COMMISSION_API_ERROR..........", error);
    throw error;
  }
};

export const processCommissionPayout = async (id, payoutData, token) => {
  try {
    console.log(`Processing payout for bus owner ID: ${id}`, payoutData);
    const response = await api.post(processCommissionPayoutEndpoint(id), payoutData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Process Payout Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("PROCESS_COMMISSION_PAYOUT_API_ERROR..........", error);
    throw error;
  }
};

export const createInfluencer = async (data, token) => {
  try {
    console.log("Creating new influencer...", data);
    const response = await api.post(influencers_API, data, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    console.log("Create Influencer Response:", response.data);
    return response.data;
  } catch (error) {
    console.log("CREATE_INFLUENCER_API_ERROR..........", error);
    throw error;
  }
};